import React from 'react';
import { Navbar, Container } from 'react-bootstrap';

const Header = () => (
  <Navbar variant="light"  style={{ height: "10vh", minWidth: "370px", backgroundColor: "#69B3FF"}}>
    <Container style={{backgroundColor: "#69B3FF"}}>
      <Navbar.Brand style={{backgroundColor: "#69B3FF", fontWeight: 'bold', fontSize: '30px', display: 'flex', alignItems: 'center' }}>
        <a href="https://messageninja.ai">
          <img src="/Logo.png" alt="Logo" style={{height: '50px', }}/>
        </a>
        <a href="https://messageninja.ai"style={{marginTop: '6px', color: 'black', textDecoration: 'none'}}>
          Wiki Ninja
        </a>
      </Navbar.Brand>
    </Container>
  </Navbar>
);


export default Header;
